import { Box, createStyles, makeStyles, TableCell, TableRow, Theme } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { Row } from 'react-table';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nonResizeable: {
      display: 'flex',
      flex: '1 0 auto !important',
    },
    clampBox: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      boxOrient: 'vertical',
      lineClamp: 2,
      display: '-webkit-box',

      // Remove with useClamp plugin implementation
      '&[data-testid="Selection"]': {
        overflow: 'visible',
      },
      '&[data-testid="fileType"], &:is(> svg)': {
        display: 'flex',
      },
    },
    menuCell: {
      justifyContent: 'center',
      paddingRight: theme.spacing(3.5),
    },
    lineThrough: {
      textDecoration: 'line-through',
      color: theme.palette.text.disabled,
    },
  }),
);

type TableRowWrapperProps<D extends Record<string, unknown>> = {
  index: number;
  row?: Row<D>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
  tableOptions?: { [key: string]: any }; // eslint-disable-line @typescript-eslint/no-explicit-any
  onRowClick?: (row: Row<D>) => void;
};

export function TableRowWrapper<T extends Record<string, unknown>>({
  index,
  row,
  style,
  tableOptions,
  onRowClick = () => undefined,
}: TableRowWrapperProps<T>) {
  const classes = useStyles();

  return (
    <TableRow
      hover
      component="div"
      {...row?.getRowProps({ style })}
      selected={row?.isSelected}
      key={index}
      data-testid={`virtualized-data-grid-row-${index}`}
    >
      {row?.cells.map((cell, cellIndex) => {
        const isMenuColumn = cell.column.Header == 'Menu';
        const isSelectionColumn = cell.column.Header == 'Selection';
        return (
          <TableCell
            {...cell.getCellProps({})}
            className={tableOptions?.disableResizing == true ? classes.nonResizeable : undefined}
            component="div"
            onClick={() => onRowClick(row)}
            data-testid={`virtualized-data-grid-cell-${index}-${cellIndex}`}
            key={`row-${index}-cell-${cellIndex}`}
          >
            <Box
              className={clsx(
                !isMenuColumn && !isSelectionColumn && classes.clampBox,
                isMenuColumn && classes.menuCell,
                row.original.shouldLineThrough ? classes.lineThrough : undefined,
              )}
              data-testid={cell.column.id}
            >
              {isMenuColumn ? cell.render('Cell', { row }) : cell.render('Cell')}
            </Box>
          </TableCell>
        );
      })}
    </TableRow>
  );
}
